import { Button, Text } from "@chakra-ui/react";
import type { SyncStatus } from "../../../../common/model/syncStatus";
import { actionButton, dangerButton } from "../../themes/design";

interface SynchronizeButtonProps {
  syncStatus: SyncStatus;
  resync: (startOver: boolean) => void;
  stopSync: () => void;
}

const SynchronizeButton: React.FC<SynchronizeButtonProps> = ({ syncStatus, resync, stopSync }) => {
  switch (syncStatus) {
    case "NOT_STARTED":
      return (
        <Button {...actionButton} mt={4} onClick={() => resync(false)}>
          Synchronize
        </Button>
      );
    case "IN_PROGRESS":
      return (
        <>
          <Text color="primary.200">Synchronizing...</Text>
          <Button {...dangerButton} mt={4} onClick={stopSync}>
            Stop
          </Button>
        </>
      );
    case "ABORTED":
      return (
        <>
          <Text color="orange.400">Synchronization stopped</Text>
          <Button {...actionButton} mt={4} onClick={() => resync(true)}>
            Continue
          </Button>
        </>
      );
    case "FINISHED_ON_ERROR":
      return (
        <>
          <Text color="red.400">Synchronization Failed</Text>
          <Button {...actionButton} mt={4} onClick={() => resync(false)}>
            Retry
          </Button>
        </>
      );
    case "FINISHED_SUCCESSFULLY":
      return <Text color="cyan.300">Synchronized</Text>;
    default:
      return null;
  }
};

export default SynchronizeButton;
